import React from 'react';
import { motion } from 'framer-motion';
export function Footer() {
  return <footer className="w-full bg-[#3D2817] py-4 md:py-8" data-id="element-96">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-98">
          <h3 className="text-xl font-bold text-[#D4A373] mb-1 md:mb-2" data-id="element-99">
            RECURSOHUB™
          </h3>
          <p className="text-base text-[#FAF1E4] font-semibold mb-1" data-id="element-100">
            El sistema N°1 para emprender con minidonas desde casa en Argentina
          </p>
          <p className="text-[#C9B59A] text-sm mb-2 md:mb-4" data-id="element-101">
            Porque emprender no debería costar años de prueba y error.
          </p>
          <div className="text-[#E8D5BA] text-sm mb-2 md:mb-4 space-y-0.5" data-id="element-102">
            <p data-id="element-103">📧 atencionrecursohub@gmail.com</p>
            <p data-id="element-104">🌐 www.recursohub.com</p>
          </div>
          <div className="text-xs text-[#9B8770] mb-2 md:mb-3" data-id="element-105">
            <p data-id="element-106">© recursoHUB™ 2026 — Todos los derechos reservados.</p>
            <p data-id="element-107">
              Prohibida la reproducción y redistribución sin autorización
              expresa.
            </p>
          </div>
          <p className="text-lg font-bold text-[#D4A373] italic" data-id="element-108">
            "La próxima semana puede ser diferente."
          </p>
        </motion.div>
      </div>
    </footer>;
}